import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  Button,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';

import { querySelector } from '../../../utils';

/* eslint-disable */
const propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.object,
  data: PropTypes.object,
  taxSchedules: PropTypes.array,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
/* eslint-enable */

const TaxScheduleInput = (props) => {
  const {
    taxSchedules, value, onChange, onBlur, onFocus, disabled,
  } = props;

  return (
    <div>
      <InputGroup>
        <DropdownList
          inputProps={{
            className: 'form-control',
          }}
          filter="contains"
          allowCreate="onFilter"
          value={value}
          data={taxSchedules}
          onChange={onChange}
          valueField="id"
          textField="display_name"
          onFocus={onFocus}
          disabled={disabled}
          onBlur={() => { onBlur(); }}
        />
        <InputGroup.Button>
          <Button
            name="cancel"
            disabled={!value}
            /* calling onBlur event to change touched flag to show error if need be */
            onClick={(e) => {
              onBlur(e);
              onChange(null);
            }}
          >
            <Glyphicon glyph="remove" />
          </Button>
        </InputGroup.Button>
      </InputGroup>
    </div>
  );
};

const GetAllTaxSchedulesQuery = gql`
  query GetAllTaxSchedules {
    all_tax_schedules {
      edges {
        node {
          id
          tax_schedule_number
          description
          display_name
        }
      }
    }
  }
`;

export const marshallData = ({ data, ownProps }) => {
  const taxSchedules = querySelector(data, '$.all_tax_schedules.edges[*].node', []);
  return {
    data,
    ...ownProps,
    taxSchedules,
  };
};

const withData = graphql(GetAllTaxSchedulesQuery, { props: marshallData, options: { fetchPolicy: 'network-only' } });

TaxScheduleInput.propTypes = propTypes;
TaxScheduleInput.defaultProps = {
  disabled: false,
};

export default withData(TaxScheduleInput);
